// Copyright (c) StrangeBee 2024

import { useLocalMessage } from '@Helpers/';
import { Divider, Space } from 'antd';
import React, { ReactElement } from 'react';
import { ICONS } from '@Constants/iconsApp';

import './WidgetFormCommon.scss';

const DividerBasics = (): ReactElement => {
    const i = useLocalMessage();
    return (
        <Divider className="no-margin-top">
            <Space>
                <ICONS.MenuOutlined className="color-primary" />
                <span className="title-3b color-primary">{i('dashboard.form-divider.basics')}</span>
            </Space>
        </Divider>
    );
};

export default DividerBasics;
